jQuery.expr[':'].DotComContains = function (a, i, m) {
	return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
};

jQuery.expr[':'].DotComSearch = function (a, i, m) {
	return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) === 0;
};

jQuery.expr[':'].ContainsSelection = function (a, i, m) {
	var mThreeSplit = m[3].split('~');
	var value = mThreeSplit[0];
	var description = $.trim(mThreeSplit[1]);
	var uiA = jQuery(a);
	return uiA.attr('smsvalue') === value && $.trim(uiA.text()) === description;
	//return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) === 0;
};

jQuery.expr[':'].DotComVisible = function (a, i, m) {
	var uiA = jQuery(a);
	return uiA.attr('visibility') != 'visible' || !(uiA.attr('display') === 'none') || uiA.width() === 0 || uiA.height() === 0;
};

jQuery.expr[':'].DotComRemoveOnUpdate = function (a, i, m) {
	var uiA = jQuery(a);
	return uiA.attr('updateoption') === 'remove' || !IsDefined(uiA.attr('updateoption')) || uiA.attr('updateoption') === '';
};

jQuery.expr[':'].DotComReloadOnUpdate = function (a, i, m) {
	return jQuery(a).attr('updateoption') === 'reload';
};

jQuery.expr[':'].DotComHasSmsField = function (a, i, m) {
	var currentSelection = m[3];
	var uiA = jQuery(a);
	if (!IsDefined(uiA.attr('selections')))
		return false;
	var selectionList = uiA.attr('selections').split(',')
	var result = ValueExistInArray(selectionList, currentSelection);
	return result;
};

$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

(function (jQuery) {
	jQuery.fn.expando = function (options) {

		var defaults = {
			contentSelector: '.ExpandoContent',
			bindEvent: 'click',
			duration: 'slow',
			headerSelector: 'h1',
			plusMinusExpandOnly: false
		}

		var opts = jQuery.extend(defaults, options);
		var expandSelector = opts.headerSelector;
		if(opts.plusMinusExpandOnly){
			expandSelector = opts.headerSelector + ' ' + '.ExpandCollapse';
		}
		this.each(function (i, o) {
			var uiO = $(o);
			
			uiO.find(opts.headerSelector).prepend('<img src=\'/Images/Common/plus_new.gif\' class=\'ExpandCollapse\' alt=\'expand\'/>&nbsp;');

			

			uiO.find(expandSelector).bind(opts.bindEvent, function () {
				uiO.find(opts.contentSelector).slideToggle(opts.duration);
				var expandCollapseImage = uiO.find('img.ExpandCollapse');
				if(expandCollapseImage.attr('src').indexOf('plus_new') === -1){
					expandCollapseImage.attr('src','/Images/Common/plus_new.gif');
				}
				else{
					expandCollapseImage.attr('src','/Images/Common/minus_new.gif');
				}
			});
		});

		return this;
	};
})(jQuery);

(function (jQuery) {
	jQuery.fn.DotComTypeAhead = function (options) {

		var defaults = {
			listBoxSelector: '',
			minCharacters: 1,
			selectMany: false
		}

		var opts = jQuery.extend(defaults, options);

		this.keyup(function (data) {
			alert(this.val());
		});

		return this;
	};
})(jQuery);

(function (jQuery) {
	jQuery.fn.idleTimeout = function (options) {
		var defaults = {
			inactivity: 1200000,
			bindEvent: 'mousemove',
			bindEventOnce: false,
			unBindEvent: false
		}
		var opts = jQuery.extend(defaults, options);
		var startTimeout = function () {
			if (_TimeOutId && opts.bindEventOnce) {
				jQuery(document).unbind(opts.bindEvent, startTimeout);
			}
			else {
				_TimeOutId = setTimeout(TimeOut, opts.inactivity);
			}
		}
		return this.each(function () {
			if (opts.unBindEvent) {
				jQuery(document).unbind(opts.bindEvent, startTimeout);
			}
			else {
				jQuery(document).bind(opts.bindEvent, startTimeout);
			}
		});
	};
})(jQuery);

jQuery.cookie = function (name, value, options) {
	// name and value given, set cookie
	if (typeof value != 'undefined') {
		options = options || {};
		if (value === null) {
			value = '';
			options.expires = -1;
		}
		var expires = '';
		if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
			var date;
			if (typeof options.expires == 'number') {
				date = new Date();
				date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
			} else {
				date = options.expires;
			}
			expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
		}
		// CAUTION: Needed to parenthesize options.path and options.domain
		// in the following expressions, otherwise they evaluate to undefined
		// in the packed version for some reason...
		var path = options.path ? '; path=' + (options.path) : '';
		var domain = options.domain ? '; domain=' + (options.domain) : '';
		var secure = options.secure ? '; secure' : '';
		document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
	}
	// only name given, get cookie
	else {
		var cookieValue = null;
		if (document.cookie && document.cookie != '') {
			var cookies = document.cookie.split(';');
			for (var i = 0; i < cookies.length; i++) {
				var cookie = jQuery.trim(cookies[i]);
				// Does this cookie string begin with the name we want?
				if (cookie.substring(0, name.length + 1) == (name + '=')) {
					cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
					break;
				}
			}
		}
		return cookieValue;
	}
};

(function (jQuery) {
	jQuery.extend({
		DotComAjax: function (options) {
			var ajaxOptions = jQuery.extend({
				// Default values (overwriteable)
				dataType: 'json',
				cache: true
			}, options.ajax || {},
			{
				type: options.type,
				target: options.target,
				global: options.global,
				cache: options.cache,
				async: options.async,
				url: options.url,
				data: options.data || {},
				error: function (req, textStatus, errorThrown) {
					HandleAjaxError(req.responseText, textStatus, errorThrown);
					if(IsDefined(options.error) && typeof options.error === 'function'){
						options.error();
					}
				},
				success: options.success,
				complete: options.complete,
				beforeSend: options.beforeSend,
				dataType: options.dataType
			});

			jQuery.ajax(ajaxOptions);
			return this;
		}
	});
})(jQuery);

(function (jQuery) {
	jQuery.fn.DotComSort = function (options) {
		var defaults = {};

		var opts = $.extend(defaults, options);

		var $r = this.children('option');
		$r.sort(function (a, b) {
			if (a.text < b.text) return -1;
			if (a.text == b.text) return 0;
			return 1;
		});
		$($r).remove();
		this.append($($r));
	};
})(jQuery);

(function (jQuery) {

	jQuery.fn.DotComFadeAppend = function (content) {
		this.css('display', 'none');
		this.append(content).fadeIn('fast');
		return this;
	};

})(jQuery);

(function (jQuery) {

	jQuery.fn.DotComFadeRemove = function (onComplete) {
		if (typeof onComplete == 'function') {
			this.fadeOut('fast', function () {
				$(this).remove();
				onComplete();
			});
		}
		else {
			this.fadeOut('slow', function () { $(this).remove(); });
		}
		return this;
	};

})(jQuery);
